import { Observable } from 'rxjs';

import { ScheduledJob, ScheduledJobRequest } from '@shure/cloud/shared/models/devices';

import {
	ScheduledJobCreateInput,
	ScheduledJobRequestsConnectionInput,
	ScheduledJobUpdateInput
} from '../api-instance-sys-api/graphql/generated/cloud-sys-api';

export type CreateScheduledJobApiInput = ScheduledJobCreateInput;
export type UpdateScheduledJobApiInput = ScheduledJobUpdateInput;
export type QueryScheduledJobRequestsApiInput = ScheduledJobRequestsConnectionInput;

export interface CreateScheduledJobMutationResult {
	scheduledJob: ScheduledJob;
	failedRequests?: string[];
}

export interface UpdateScheduledJobMutationResult {
	scheduledJob: ScheduledJob;
	failedRequests?: string[];
}

export abstract class ScheduledJobsApiService {
	public abstract getScheduledJobs$(): Observable<ScheduledJob[]>;
	public abstract getScheduledJobsCount$(): Observable<number>;
	public abstract fetchScheduledJob$(
		jobId: string,
		options?: { skipCache?: boolean }
	): Observable<ScheduledJob | null>;
	public abstract isLoadingJobs$(): Observable<boolean>;
	public abstract loadScheduledJobs(opts?: { refresh: boolean }): void;

	public abstract getScheduledJobRequests$(
		input: QueryScheduledJobRequestsApiInput
	): Observable<ScheduledJobRequest[]>;
	public abstract isLoadingScheduledJobRequests$(input: QueryScheduledJobRequestsApiInput): Observable<boolean>;
	public abstract loadScheduledJobRequests(input: QueryScheduledJobRequestsApiInput): void;

	public abstract createScheduledJob(input: CreateScheduledJobApiInput): Observable<CreateScheduledJobMutationResult>;
	public abstract updateScheduledJob(input: UpdateScheduledJobApiInput): Observable<UpdateScheduledJobMutationResult>;
	public abstract cancelScheduledJob(jobNodeId: string): Observable<void>;
	public abstract startScheduledJob(jobNodeId: string): Observable<void>;
}
